/* Testimonial slideshow — quotes crossfade on a timer, pause on hover and on focus.
   Deliberately a sibling of hero-slideshow.js rather than a shared engine: that one
   hardcodes .hero__slide--on, and generalising it would mean editing the one piece of
   scripted motion on the page that is already working. Every string a viewer reads is
   in the DOM already, one per block; this file never builds copy.
   prefers-reduced-motion disables the auto-advance; the fade is disabled in CSS. */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Quotes(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-quote-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-quote-dot]'));
    this.interval = parseInt(root.dataset.quoteInterval, 10) || 9000;
    this.index = 0;
    this.timer = null;

    if (this.slides.length < 2) return;

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        this.show(i);
        this.restart();
      }.bind(this));
    }.bind(this));

    root.addEventListener('mouseenter', this.stop.bind(this));
    root.addEventListener('mouseleave', this.start.bind(this));
    root.addEventListener('focusin', this.stop.bind(this));
    root.addEventListener('focusout', this.start.bind(this));

    /* The viewer's own hold, which outranks hover and focus — see hero-slideshow.js. */
    var self = this;
    this.paused = false;
    this.toggle = root.querySelector('[data-quote-pause-toggle]');
    if (this.toggle) {
      this.toggle.addEventListener('click', function () {
        self.paused = !self.paused;
        self.toggle.setAttribute('aria-pressed', String(self.paused));
        self.toggle.textContent = self.paused
          ? (root.dataset.quotePlay || 'Play')
          : (root.dataset.quotePause || 'Pause');
        if (self.paused) { self.stop(); } else { self.start(true); }
      });
    }

    /* Same swipe and arrow-key contract as the two image galleries. The surface is the
       stage rather than the whole band, so a swipe has to land on the quote itself and
       the dots below stay a separate target. Advancing by hand restarts the timer, as a
       dot click does — nobody wants the thing they just chose to slide away early. */
    if (typeof window.galleryNav === 'function') {
      window.galleryNav(root.querySelector('.quotes__stage'), {
        prev: function () { this.show(this.index - 1); this.restart(); }.bind(this),
        next: function () { this.show(this.index + 1); this.restart(); }.bind(this),
        /* A distinct name. Copying the region's own aria-label made a screen reader
           announce "What customers say" twice, once nested inside the other. */
        label: root.dataset.quoteGroupLabel || 'Quotes' 
      });
    }

    /* The dots are outside the stage here too — see hero-slideshow.js. */
    var dotRow = root.querySelector('.quotes__dots');
    if (dotRow) {
      dotRow.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.show(self.index - 1); }
        else if (e.key === 'ArrowRight') { self.show(self.index + 1); }
        else { return; }
        e.preventDefault();
        if (self.dots[self.index]) self.dots[self.index].focus();
        self.restart();
      });
    }

    this.start();
  }

  Quotes.prototype.show = function (next) {
    this.index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach(function (slide, i) {
      var on = i === this.index;
      slide.classList.toggle('quotes__slide--on', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) { slide.removeAttribute('inert'); } else { slide.setAttribute('inert', ''); }
    }.bind(this));
    this.dots.forEach(function (dot, i) {
      if (i === this.index) { dot.setAttribute('aria-current', 'true'); }
      else { dot.removeAttribute('aria-current'); }
    }.bind(this));
  };

  Quotes.prototype.start = function (force) {
    if (REDUCE.matches || this.slides.length < 2 || this.paused) return;
    /* Choosing a quote by hand parks focus on the dot and the pointer on the band; without
       this the timer restarted anyway and moved the quote the viewer had just chosen.
       Pressing Play overrides it — see hero-slideshow.js. */
    if (!force && (this.root.matches(':hover') || this.root.contains(document.activeElement))) return;
    this.stop();
    this.timer = setInterval(function () { this.show(this.index + 1); }.bind(this), this.interval);
  };

  Quotes.prototype.stop = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  Quotes.prototype.restart = function () { this.stop(); this.start(); };

  function init(scope) {
    (scope || document).querySelectorAll('[data-quotes]').forEach(function (root) {
      if (root.dataset.quotesReady) return;
      root.dataset.quotesReady = 'true';
      new Quotes(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  init(document);
})();
